<template>
  <v-container fluid grid-list-lg>
    <v-card>
      <v-toolbar>
        <v-icon>ballot</v-icon>
        <v-toolbar-title class="font-weight-light"
          >&nbsp;Paso de Debitar a Impactar</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              icon
              color="red"
              v-on="on"
              @click="setStatusTareaFrecuente(action)">
              <v-icon v-if="action.esFrecuente">favorite</v-icon>
              <v-icon v-else>favorite_border</v-icon>
            </v-btn>
          </template>
          <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>
          <span v-else>Agregar a Tareas Frecuentes</span>
        </v-tooltip>
      </v-toolbar>

      <v-card-text>
        <v-row align="center" dense>
          <v-col>
            <v-file-input
              v-model="archivosASubir"
              dense
              placeholder="Seleccione el Archivo a Procesar"
              label="Archivo a Procesar"
              @change="recordsPreProceso = []"
              counter
              show-size
              prepend-icon="mdi-paperclip">
            </v-file-input>
          </v-col>
          <v-col cols="2"> </v-col>

          <v-col cols="4" lg="2" v-if="archivosASubir">
            <v-btn
              :disabled="loading"
              text
              class="black--text green"
              @click.native="ProcesarArchivo"
              small>
              Procesar &nbsp;
              <v-progress-circular
                v-if="loading"
                indeterminate
                size="20"></v-progress-circular>
            </v-btn>

            <!-- <v-btn text dark class="green" @click="wea"  >
                               Try
                            </v-btn> -->
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card-text v-if="records != 0">
      Se han procesado {{ records }} registros.
    </v-card-text>

    <!-- process progress -->

    <template v-if="$store.state.debugModeOn">
      Debug Info:
      <p></p>

      Model: {{}}
      <p></p>
    </template>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
import { Decimal } from "decimal.js";

import { http } from "@/axios";
import Vue from "vue";
import {
  //mapState,
  mapGetters,
  mapMutations,
  mapActions,
} from "vuex";

export default {
  data() {
    return {
      // totalRegistros: 0,
      loading: false,
      editMode: false,
      suspend: false,
      search: "", // valor para búsqueda
      records: [], // registros
      recordsProceso: [],
      recordsPreProceso: [],
      recordsAProcesar: [],
      recordsLotesCardCred: [],
      recordsLog: [],
      totalItemsLog: 0,
      totalItemsLotesCardCred: 0,
      optionsLog: {
        // definición de paginación
        sortDesc: [true],
        sortBy: ["lote"],
        page: 1,
        itemsPerPage: 5,
        rowsPerPageItems: [5, 10, 20],
      },
      archivosASubir: null,
    };
  },

  watch: {},

  computed: {
    ...mapGetters([
      "getActionFromLink",
      "error",
      "user",
      "ParametrosGenerales",
    ]),
    action: function () {
      return this.getActionFromLink(this.$route.path);
    },
  },
  methods: {
    ...mapMutations([
      "alertClear",
      "alertSuccess",
      "alertWarning",
      "alertError",
      "setReporteActivo",
    ]),
    ...mapActions(["setStatusTareaFrecuente"]),

    async downloadFile(file, renameTo) {
      //convierto el string del path a base64 para poder mandarlo
      let base64String = "";
      base64String = btoa(file.fullPath);

      http
        .get("filemanagement/getfilebypath/" + base64String)
        .then((resp) => {
          let dataType = "";
          switch (resp.extension) {
            case ".doc":
            case ".docx":
            case ".DOC":
            case ".DOCX":
              dataType = "data:application/vnd.ms-word";
              break;
            case ".pdf":
            case ".PDF":
              dataType = "data:application/pdf";
          }

          //necesito hacer esto del arrayBuffer para que despues se pueda hacer el blob
          var arrayBuffer = this.base64ToArrayBuffer(resp.file);
          this.saveByteArray(renameTo, arrayBuffer, dataType);
        })
        .catch((e) => this.alertError(e));
    },
    base64ToArrayBuffer(base64) {
      var binaryString = window.atob(base64);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    },
    saveByteArray(fileName, byteArrayBuffer, dataType) {
      var blob = new Blob([byteArrayBuffer], { type: dataType });
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    },
    async imprimirRespaldatorio(item) {
      let params = [];
      params.push({
        Version: this.$store.state.version, // version
        LoteProcesoId: item.id,
        ImputacionPendiente: false,
      });
    },

    async ProcesarArchivo() {
      var mensaje = "";
      var self = this;

      if (mensaje != "") {
        const res = await this.$dialog.confirm({
          text: mensaje + "?",
          title: "Proceso de Pase de Débito a AImputar",
          persistent: true, // Parece que no funciona...
        });

        if (!res) return;
      }

      this.loading = true;

      const formData = new FormData();
      formData.append("excelFile", this.archivosASubir);

      try {
        await http
          .post("/archivosDebito/pasarDebitoAImpactar", formData)
          .then((resp) => {
            console.log(resp);

            if (resp.error) {
              this.alertError(resp.error);
            } else {
              self.alertSuccess(
                "Se procesó correctamenta el archivo. Aguarde unos instantes mientras se descarga el resultado..."
              );

              self.loading = true;
              self.downloadFile(resp, "PasajeDeADebitarAaImpactar.csv");
              self.loading = false;
            }
          })
          .catch((e) => {
            self.alertError(e);
          });
      } catch (error) {
        // Error
        this.alertError(error);
      }

      this.loading = false;
    },
  },
};
</script>
